<template>
<section id="xiami">
<iframe
  title="Codster Chat"
  src="https://xami.codster.io/?application_id=72cd0565-a4ee-457e-b90f-5d2dd4f17d40"
  width="100%"
  height="600vh"
></iframe></section>
</template>



<script setup>
const static_url =  process.env.VUE_APP_STATIC_URL;
</script>